// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useContext } from 'react';
import { InternalComponentIconsContext } from './context';
/** Returns the custom icons provided for the given component via `IconProvider` `componentIcons`. */
export function useInternalComponentIcons(component) {
    return useContext(InternalComponentIconsContext)[component];
}
//# sourceMappingURL=use-component-icons.js.map